import { Announcement } from "./types";

export const announcements: Record<string, Announcement> = {};
